export default "__VITE_ASSET__BWm$nKay__"